import styled from 'styled-components';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FormWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

const SelectInput = styled.input`
  background: 0px center;
  border: 0px;
  color: inherit;
  font: inherit;
  grid-area: 1 / 2;
  margin: 0px;
  min-width: 2px;
  opacity: 1;
  outline: 0px;
  padding: 0px;
  width: 100%;
  z-index: 999;
`;

const SelectInputWrapper = styled.div`
  -ms-flex: 1 1 auto;
  -webkit-flex: 1 1 auto;
  box-sizing: border-box;
  color: hsl(0, 0%, 20%);
  display: inline-grid;
  flex: 1 1 auto;
  grid-area: 1 / 1 / 2 / 3;
  grid-template-columns: 0 min-content;
  margin: 2px;
  padding-bottom: 2px;
  padding-top: 2px;
  visibility: visible;
  z-index: 999;
`;

export { FormWrapper, ModalContent, SelectInput, SelectInputWrapper };
